import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { InputPassword } from '@isyc-react/form/modules/input/password';
import { FormSize } from '@isyc-react/form/view-model';
import { RippleButton } from '@isyc-react/form/modules/base/button';
import "./pdf-password-unlock.style.scss";
export const PdfPasswordUnlock = props => {
  const {
    onUnlock
  } = props;
  const [password, setPassword] = React.useState('');
  return /*#__PURE__*/React.createElement("div", {
    className: "pdf-password-unlock"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Enter the password to unlock the PDF file ", /*#__PURE__*/React.createElement("span", {
    className: "text-red"
  }, "*"), ' '), /*#__PURE__*/React.createElement(InputPassword, {
    size: FormSize.LG,
    value: password,
    onChange: setPassword
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-primary",
    onClick: () => {
      onUnlock && onUnlock(password);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-lock-open"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ms-2"
  }, "Unlock")))));
};